import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { convertArrToObj } from 'lib/src/utils/generic';
import {
    fetchAllChallengeTagsRequest,
    fetchAllChallengeTagsSuccess,
    fetchAllChallengeTagsFailure,
} from '@actions/challengeTags';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';
import {
    deleteTagFailure,
    deleteTagRequest,
    deleteTagSuccess,
} from '@actions/challengeTags/deleteTag';
import { editTagFailure, editTagRequest, editTagSuccess } from '@actions/challengeTags/editTag';
import {
    fetchAllBusinessTagsFailure,
    fetchAllBusinessTagsRequest,
    fetchAllBusinessTagsSuccess,
} from '@actions/challengeTags/fetchAllBusinessTags';
import {
    postCreateTagFailure,
    postCreateTagRequest,
    postCreateTagSuccess,
} from '@actions/challengeTags/postCreateTag';

interface ChallengeTagsState {
    challengeTags: Record<number, ChallengeTag>;
    isFetching: boolean;
    fetchError: string | null;
    isPosting: boolean;
    postError: string | null;
    postSuccess: boolean;
    isDeleting: boolean;
    deleteError: string | null;
    deleteSuccess: boolean;
}

const initialState: ChallengeTagsState = {
    challengeTags: {},
    isFetching: false,
    fetchError: null,
    isPosting: false,
    postError: null,
    postSuccess: false,
    isDeleting: false,
    deleteError: null,
    deleteSuccess: false,
};

export default createReducer(initialState, {
    [fetchAllChallengeTagsRequest.type]: handleFetchRequest,
    [fetchAllChallengeTagsSuccess.type]: handleFetchAllChallengeTagsSuccess,
    [fetchAllChallengeTagsFailure.type]: handleFetchFailure,
    [fetchAllBusinessTagsRequest.type]: handleFetchRequest,
    [fetchAllBusinessTagsSuccess.type]: handleFetchAllChallengeTagsSuccess,
    [fetchAllBusinessTagsFailure.type]: handleFetchFailure,
    [deleteTagRequest.type]: handleDeleteRequest,
    [deleteTagSuccess.type]: handleDeleteSuccess,
    [deleteTagFailure.type]: handleDeleteFailure,
    [editTagRequest.type]: handlePostRequest,
    [editTagSuccess.type]: handlePostSuccess,
    [editTagFailure.type]: handlePostFailure,
    [postCreateTagRequest.type]: handlePostRequest,
    [postCreateTagSuccess.type]: handlePostSuccess,
    [postCreateTagFailure.type]: handlePostFailure,
});

function handleFetchRequest(state: ChallengeTagsState) {
    state.isFetching = true;
    state.fetchError = null;
}

function handlePostRequest(state: ChallengeTagsState) {
    state.isPosting = true;
    state.postSuccess = false;
}

function handleFetchFailure(state: ChallengeTagsState, action: PayloadAction<string>) {
    state.fetchError = action.payload;
    state.isFetching = false;
}
function handlePostFailure(state: ChallengeTagsState, action: PayloadAction<string>) {
    state.postError = action.payload;
    state.isPosting = false;
}
function handlePostSuccess(state: ChallengeTagsState, action: PayloadAction<ChallengeTag>) {
    state.isPosting = false;
    state.postSuccess = true;
    state.challengeTags[action.payload.id] = action.payload;
}

function handleDeleteRequest(state: ChallengeTagsState, action: PayloadAction<number>) {
    state.deleteSuccess = false;
    state.deleteError = null;
    state.isDeleting = true;
}
function handleDeleteFailure(state: ChallengeTagsState, action: PayloadAction<string>) {
    state.isDeleting = false;
    state.deleteError = action.payload;
}
function handleDeleteSuccess(state: ChallengeTagsState, action: PayloadAction<number>) {
    state.isDeleting = false;
    delete state.challengeTags[action.payload];
    state.deleteSuccess = true;
}

function handleFetchAllChallengeTagsSuccess(
    state: ChallengeTagsState,
    action: PayloadAction<ChallengeTag[]>,
) {
    state.challengeTags = { ...state.challengeTags, ...convertArrToObj(action.payload) };
    state.isFetching = false;
}
